import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getSubCategories() {
  yield takeEvery(actions.FETCH_SUBCATEGORIES_REQUESTED, function* (action) {
    try {
      
      const subCategories = yield call(actions.getSubCategories, action.payload);
      yield put({ type: actions.FETCH_SUBCATEGORIES_SUCCEEDED, subCategories });
    } catch (error) {
      yield put({ type: actions.FETCH_SUBCATEGORIES_FAILED, error: error.message });
    }
  });
}

export function* deleteSubCategory() {
  yield takeEvery(actions.DELETE_SUBCATEGORY_REQUESTED, function* (action) {
      try {
          const subCategory = yield call(actions.deleteSubCategory, action.payload);
          console.log("subcategory", subCategory);
          yield put({ type: actions.DELETE_SUBCATEGORY_SUCCEEDED, subCategoryDeleted: subCategory });
      } catch (error) {
          yield put({ type: actions.DELETE_SUBCATEGORY_FAILED, error: error.response.data });
      }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getSubCategories),
    fork(deleteSubCategory),
  ]);
}
